export const SHOW_CLUSTER_MODAL = 'SHOW_CLUSTER_MODAL';
export const HIDE_CLUSTER_MODAL = 'HIDE_CLUSTER_MODAL';

export const SET_CLUSTER_ASSIGN_MODAL_SELECTED_VALUES = 'SET_CLUSTER_ASSIGN_MODAL_SELECTED_VALUES';
